var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 1L1 4.5L4 8","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronLeft.defaultProps = {"width":"5","height":"9","viewBox":"0 0 5 9","fill":"none"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
